// Actions
import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for PermissionsStore, for use in the registry */ export const PermissionsStoreActionTypes = [
    ActionType.FetchAppContextSucceeded,
    ActionType.SetTenantPlannerCopilotEnabledSettingAction,
    ActionType.FetchTenantFeatureSettingsSucceededAction,
    ActionType.FetchTenantGroupSettingsSucceededAction,
    ActionType.FetchUserFeatureEntitlementsSucceededAction,
    ActionType.SetDefaultPlanAction,
    ActionType.SetFlaggedEmailPlanAction,
    ActionType.FetchEntityAction,
    ActionType.FetchEntitySucceededAction,
    ActionType.FetchEntityFailedAction
];
